module.exports = __webpack_public_path__ + "img/89.710aae26.jpg";